import { render } from "./MiniHeader.vue?vue&type=template&id=4fb37164"
import script from "./MiniHeader.vue?vue&type=script&lang=js"
export * from "./MiniHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__